<template>
  <div class="qr-code-styled">
    <div ref="qrContainer" class="qr-code-styled__container"></div>
    <div v-if="showDownload" class="qr-code-styled__actions">
      <button type="button" class="qr-code-styled__btn" @click="download('png')">
        <i class="uil-import"></i> PNG
      </button>
      <button type="button" class="qr-code-styled__btn" @click="download('svg')">
        <i class="uil-import"></i> SVG
      </button>
    </div>
  </div>
</template>

<script>
import QRCodeStyling from 'qr-code-styling';

export default {
  name: 'QrCodeStyled',
  props: {
    data: {
      type: String,
      required: true,
    },
    size: {
      type: Number,
      default: 200,
    },
    image: {
      type: String,
      default: '',
    },
    imageSize: {
      type: Number,
      default: 0.4,
    },
    dotsType: {
      type: String,
      default: 'rounded',
      validator: (v) => ['rounded', 'dots', 'classy', 'classy-rounded', 'square', 'extra-rounded'].includes(v),
    },
    dotsColor: {
      type: String,
      default: '#000000',
    },
    dotsGradient: {
      type: Object,
      default: null,
    },
    cornersSquareType: {
      type: String,
      default: 'extra-rounded',
      validator: (v) => ['dot', 'square', 'extra-rounded'].includes(v),
    },
    cornersSquareColor: {
      type: String,
      default: '#000000',
    },
    cornersDotType: {
      type: String,
      default: 'dot',
      validator: (v) => ['dot', 'square'].includes(v),
    },
    cornersDotColor: {
      type: String,
      default: '#000000',
    },
    backgroundColor: {
      type: String,
      default: '#ffffff',
    },
    showDownload: {
      type: Boolean,
      default: false,
    },
    margin: {
      type: Number,
      default: 10,
    },
    errorCorrectionLevel: {
      type: String,
      default: 'H',
      validator: (v) => ['L', 'M', 'Q', 'H'].includes(v),
    },
    downloadSize: {
      type: Number,
      default: 1000,
    },
    downloadFileName: {
      type: String,
      default: 'qr-code',
    },
  },
  data() {
    return {
      qrCode: null,
    };
  },
  computed: {
    qrOptions() {
      const options = {
        width: this.size,
        height: this.size,
        type: 'svg',
        data: this.data,
        margin: this.margin,
        qrOptions: {
          errorCorrectionLevel: this.errorCorrectionLevel,
        },
        dotsOptions: {
          color: this.dotsColor,
          type: this.dotsType,
        },
        cornersSquareOptions: {
          color: this.cornersSquareColor,
          type: this.cornersSquareType,
        },
        cornersDotOptions: {
          color: this.cornersDotColor,
          type: this.cornersDotType,
        },
        backgroundOptions: {
          color: this.backgroundColor,
        },
      };

      if (this.dotsGradient) {
        options.dotsOptions.gradient = this.dotsGradient;
      }

      if (this.image) {
        options.image = this.image;
        options.imageOptions = {
          crossOrigin: 'anonymous',
          margin: 5,
          imageSize: this.imageSize,
        };
      }

      return options;
    },
  },
  watch: {
    data() {
      this.updateQrCode();
    },
    qrOptions: {
      deep: true,
      handler() {
        this.updateQrCode();
      },
    },
  },
  mounted() {
    this.initQrCode();
  },
  beforeDestroy() {
    this.qrCode = null;
  },
  methods: {
    initQrCode() {
      this.qrCode = new QRCodeStyling(this.qrOptions);
      this.qrCode.append(this.$refs.qrContainer);
    },
    updateQrCode() {
      if (this.qrCode) {
        this.qrCode.update(this.qrOptions);
      }
    },
    download(extension = 'png') {
      // Yüksek çözünürlüklü indirme için yeni QR oluştur
      const downloadOptions = {
        ...this.qrOptions,
        width: this.downloadSize,
        height: this.downloadSize,
        type: extension === 'svg' ? 'svg' : 'canvas',
      };

      const downloadQr = new QRCodeStyling(downloadOptions);
      downloadQr.download({
        extension: extension,
        name: this.downloadFileName,
      });
    },
  },
};
</script>

<style scoped>
.qr-code-styled {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}

.qr-code-styled__container {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #ffffff;
  border-radius: 16px;
  padding: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
}

.qr-code-styled__container >>> svg {
  display: block;
  border-radius: 8px;
}

.qr-code-styled__actions {
  display: flex;
  gap: 8px;
}

.qr-code-styled__btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  font-size: 13px;
  font-weight: 600;
  color: #475569;
  background: #f1f5f9;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s;
}

.qr-code-styled__btn:hover {
  background: #e2e8f0;
  color: #1e293b;
}

.qr-code-styled__btn i {
  font-size: 14px;
}
</style>
